import { Modal } from 'antd'
import { Cookies } from 'react-cookie'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import { SignerApi } from '../../api/SignerApi'
import { history } from '../../index'
import { apiReject } from '../../redux/api/actions'
import { GlobalHandler } from '../../utils/ReduxUtils'
import {
  createAccountFulfilled,
  createAccountRequest,
  lawyerQueryFulfilled,
  lawyerQueryRequest,
  payment3DSFulfilled,
  previewCampainContractFulfilled,
  previewCampainContractRejected,
  previewCampainContractRequest,
  previewDealerContractFulfilled,
  previewDealerContractRejected,
  previewDealerContractRequest,
  signCampainContractFulfilled,
  signCampainContractRejected,
  signDealerContractFulfilled,
  signDealerContractRejected,
  stepInfoCheckFulfilled,
  stepInfoCheckRequest,
} from './actions'
import { ActionTypes } from './types'
const cookies = new Cookies()

function* handleCreateAccountRequest(action: ReturnType<typeof createAccountRequest>) {
  const { response: axiosResponse, error } = yield GlobalHandler(
    call(SignerApi.accountCreate, action.payload),
    false,
  )

  const response = axiosResponse.data

  if (response) {
    // var response = JSON.parse(message.body) as CreateAccountResponse

    var createRequest = response.accountInfo

    if (response.result) {
      if (
        createRequest.campainInfo !== null &&
        createRequest.campainInfo !== undefined &&
        createRequest.selectedPlanCode !== null &&
        createRequest.selectedPlanCode !== undefined
      ) {
        var selectedPlan = createRequest.campainInfo.plans.find(
          (x) => x.code === createRequest.selectedPlanCode,
        )

        const { response: paymentResponse, error } = yield GlobalHandler(
          call(SignerApi.signerPaymentRequest, {
            productType: 'SignerPayment',
            invoiceInfo: {
              registerNumber: createRequest.generalInfo.registerNumber,
              fullName: createRequest.generalInfo.fullName,
              street: createRequest.addressInfo.street,
              district: createRequest.addressInfo.district,
              postalCode: createRequest.addressInfo.zipPostalCode,
              city: createRequest.addressInfo.city,
              country: createRequest.addressInfo.country,
              phone: createRequest.addressInfo.phone,
              fax: createRequest.addressInfo.fax,
              mail: createRequest.addressInfo.email,
              webSite: createRequest.addressInfo.webSite,
              taxOffice: createRequest.addressInfo.taxOffice,
            },
            creditCardInfo: cookies.get('payment-info'),
            orderInfo: {
              payableAmount: Math.round(selectedPlan.amount * 1.18 * 100) / 100,
              items: [
                {
                  Description: selectedPlan.title + ' ' + selectedPlan.altTitle,
                  Quantity: 1,
                  Price: selectedPlan.amount,
                  VatPercent: 18,
                },
              ],
              webSite: 'https://aktivasyon.nesbilgi.com.tr',
              orderId: createRequest.orderId,
            },
            orderId: createRequest.orderId,
          }),
          false,
        )

        if (paymentResponse) {
          if (paymentResponse.data.status === 'success') {
            return yield put(payment3DSFulfilled(paymentResponse.data))
          } else {
            Modal.error({
              title: 'Ödeme alınırken problem oluştu!',
              content: paymentResponse.data.errorCode + ':' + paymentResponse.data.errorMessage,
              onOk() {},
            })
          }
        }
      } else {
        // dispatch(createAccountFulfilled(response))

        Modal.info({
          title: 'Hesap açılış talebiniz alındı.',
          content: 'Durumlarını sorgulamak için yönlendirileceksiniz.',
          onOk() {
            history.push('/info')
          },
        })

        return yield put(createAccountFulfilled(response.data))
      }
    } else {
      Modal.error({
        title: 'Hesap açılış talebiniz alınamadı!',
        content: response.errorMessage,
        onOk() {},
      })
      return yield put(apiReject(error))
    }
  }
  if (error) {
    return yield put(apiReject(error))
  }
}

function* handlelawyerQueryRequest(action: ReturnType<typeof lawyerQueryRequest>) {
  const { response, error } = yield GlobalHandler(
    call(SignerApi.lawyerQuery, action.payload),
    false,
  )
  if (response) return yield put(lawyerQueryFulfilled(response.data))
  if (error) {
    return yield put(apiReject(error))
  }
}

function* handleDealerPreviewContractRequest(
  action: ReturnType<typeof previewDealerContractRequest>,
) {
  const { response, error } = yield GlobalHandler(
    call(SignerApi.previewContract, action.payload),
    false,
  )
  if (response) {
    return yield put(previewDealerContractFulfilled(response.data))
  }
  if (error) {
    return yield put(previewDealerContractRejected(error))
  }
}

function* handleCampainPreviewContractRequest(
  action: ReturnType<typeof previewCampainContractRequest>,
) {
  const { response, error } = yield GlobalHandler(
    call(SignerApi.previewContract, action.payload),
    false,
  )
  if (response) {
    return yield put(previewCampainContractFulfilled(response.data))
  }
  if (error) {
    return yield put(previewCampainContractRejected(error))
  }
}

function* handleSignDealerContractRequest(action: ReturnType<typeof createAccountRequest>) {
  const { response, error } = yield GlobalHandler(
    call(SignerApi.signDealerContract, action.payload),
    false,
  )
  if (response) return yield put(signDealerContractFulfilled(response.data))
  if (error) {
    Modal.error({
      title: 'İmzalama Hatası',
      content: error.response != undefined ? error.response.data.message : error.toString(),
    })
    return yield put(signDealerContractRejected())
  }
}

function* handleSignCampainContractRequest(action: ReturnType<typeof createAccountRequest>) {
  const { response, error } = yield GlobalHandler(
    call(SignerApi.signCampainContract, action.payload),
    false,
  )
  if (response) return yield put(signCampainContractFulfilled(response.data))
  if (error) {
    Modal.error({
      title: 'İmzalama Hatası',
      content: error.response != undefined ? error.response.data.message : error.toString(),
    })
    return yield put(signCampainContractRejected())
  }
}

function* handleStepInfoCheckRequest(action: ReturnType<typeof stepInfoCheckRequest>) {
  const { response, error } = yield GlobalHandler(
    call(SignerApi.checkStepDetail, action.payload.dealerCode, action.payload.campainCode),
    false,
  )
  if (response)
    return yield put(
      // stepInfoCheckFulfilled({ ...response.data, isQualified: action.payload.isQualified }),
      stepInfoCheckFulfilled({ ...response.data, isQualified: true }),
    )
  // if (error) return yield put(accountInfoReject(response))
}

function* SmartCardSaga() {
  yield all([
    takeLatest(ActionTypes.CREATE_ACCOUNT_REQUEST, (action: any) =>
      handleCreateAccountRequest(action),
    ),
    takeLatest(ActionTypes.LAWYER_QUERY_REQUEST, (action: any) => handlelawyerQueryRequest(action)),
    takeLatest(ActionTypes.STEP_INFO_CHECK_REQUEST, (action: any) =>
      handleStepInfoCheckRequest(action),
    ),
    takeLatest(ActionTypes.PREVIEW_DEALER_CONTRACT_REQUEST, (action: any) =>
      handleDealerPreviewContractRequest(action),
    ),
    takeLatest(ActionTypes.PREVIEW_CAMPAIN_CONTRACT_REQUEST, (action: any) =>
      handleCampainPreviewContractRequest(action),
    ),
    takeLatest(ActionTypes.SIGN_DEALER_CONTRACT_REQUEST, (action: any) =>
      handleSignDealerContractRequest(action),
    ),
    takeLatest(ActionTypes.SIGN_CAMPAIN_CONTRACT_REQUEST, (action: any) =>
      handleSignCampainContractRequest(action),
    ),
  ])
}

export default SmartCardSaga
